<!--跟进记录-->
<template>
    <el-dialog :close-on-click-modal="false" :title="`【${EntpCusName}】跟进记录`" :visible="dialogVisible" width="1200px" :show-close="true" :before-close="handleClose">
        <div style="margin-top: 10px" v-loading="loading">
            <el-container>
                <el-header style="height: auto">
                    <el-form ref="addRecordsform" :model="addRecordsModel" :rules="rules" label-width="80px" style="width: 100%" size="medium">
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="跟进类型" prop="FolloweType">
                                    <el-autocomplete
                                        clearable
                                        popper-class="autocomplete"
                                        v-model.trim="addRecordsModel.FolloweType"
                                        :fetch-suggestions="searchFolloweType"
                                        @select="selectType"
                                        @clear="clearType"
                                        @input="typeInput"
                                        value-key="Name"
                                    ></el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :span="16">
                                <el-form-item label="是否预约" prop="ReservationTime">
                                    <el-col :span="3">
                                        <el-switch v-model="addRecordsModel.Reserved"></el-switch>
                                    </el-col>
                                    <el-col class="line" :span="4">预约跟进时间</el-col>
                                    <el-col :span="11">
                                        <el-date-picker
                                            :disabled="!addRecordsModel.Reserved"
                                            type="datetime"
                                            format="yyyy-MM-dd HH:mm"
                                            value-format="yyyy-MM-dd HH:mm"
                                            placeholder="选择下次跟进时间"
                                            v-model="addRecordsModel.ReservationTime"
                                            style="width: 100%"
                                        ></el-date-picker>
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="跟进内容" prop="FollowContent">
                                    <el-input type="textarea" v-model="addRecordsModel.FollowContent" maxlength="500" show-word-limit></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="跟进结果" prop="FollowResult">
                                    <el-input type="textarea" v-model="addRecordsModel.FollowResult" maxlength="500" show-word-limit></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item style="float: right">
                            <el-button type="primary" @click="onSubmit('addRecordsform')">提交</el-button>
                            <el-button @click="resetForm('addRecordsform')">重置</el-button>
                        </el-form-item>
                    </el-form>
                </el-header>
                <el-main>
                    <div class="search-ctn">
                        <div class="search-ctn-left">
                            <div class="search-name">跟进时间</div>
                            <div class="search-name">
                                <el-date-picker
                                    v-model="dateTimes"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm"
                                    type="datetimerange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    size="small"
                                    @change="TimeChange"
                                ></el-date-picker>
                            </div>
                            <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        </div>
                    </div>
                    <div class="table-ctn">
                        <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="followsRecordsList" border="" style="width: 100%; margin-bottom: 0">
                            <el-table-column prop="FolloweType" label="跟进类型" show-overflow-tooltip width="120px"></el-table-column>
                            <el-table-column prop="FollowContent" label="跟进内容" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="FollowResult" label="跟进结果" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Follower" label="跟进人" show-overflow-tooltip width="80px"></el-table-column>
                            <el-table-column prop="CreateTimeStr" label="跟进时间" show-overflow-tooltip width="140px"></el-table-column>
                            <el-table-column prop="Reserved" label="是否预约" show-overflow-tooltip width="80px"></el-table-column>
                            <el-table-column prop="ReservationTime" label="下次跟进时间" show-overflow-tooltip width="140px"></el-table-column>
                        </el-table>
                    </div>
                    <div class="pagination-ctn" style="position: unset; text-align: right; border-top: none">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="searchParams.page"
                            :page-sizes="[5, 10, 20, 30, 40, 50]"
                            :page-size="searchParams.limit"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="followsRecordsLength"
                        ></el-pagination>
                    </div>
                </el-main>
            </el-container>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        EntpCusId: String,
        EntpCusName: String
    },
    data() {
        let checkReservationTime = (rule, value, callback) => {
            if (this.addRecordsModel.Reserved && !value) {
                return callback(new Error('请输入预约时间'));
            }
            if (new Date().getTime() > new Date(value).getTime()) {
                return callback(new Error('预约时间必须大于当前时间'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            followsTypeList: [],
            followsRecordsList: [],
            followsRecordsLength: 0,
            searchParams: {
                cid: this.EntpCusId,
                startTime: '',
                endTime: '',
                page: 1,
                limit: 5
            },
            dateTimes: '',
            addRecordsModel: {
                EntpCusId: this.EntpCusId,
                FollowContent: '',
                FollowResult: '',
                FolloweTypeId: '',
                FolloweType: '',
                FolloweTypeOrigin: 1,
                Reserved: false,
                ReservationTime: ''
            },
            rules: {
                FolloweType: [{ required: true, message: '请选择跟进类型', trigger: 'change' }],
                FollowContent: [{ required: true, message: '请输入跟进内容', trigger: 'blur' }],
                FollowResult: [{ required: true, message: '请输入跟进结果', trigger: 'blur' }],
                ReservationTime: [{ validator: checkReservationTime, trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getFollowsRecordsList();
        this.getFollowsTypeList();
    },
    methods: {
        getFollowsTypeList() {
            let url = '/api/EntpCustomers/GetFollowsTypeList';
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        this.followsTypeList = res.data;
                    }
                })
                .catch(() => {});
        },
        getFollowsRecordsList() {
            this.loading = true;
            let url = '/api/EntpCustomers/GetFollowsRecordsList';
            this.$util
                .axiosGet({
                    url: url,
                    hideLoading: true,
                    data: this.searchParams
                })
                .then(res => {
                    if (res.data) {
                        this.followsRecordsList = res.data;
                        this.followsRecordsLength = res.count;
                    } else {
                        this.followsRecordsList = [];
                        this.followsRecordsLength = 0;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchParams.page = 1;
            this.getFollowsRecordsList();
        },
        handleSizeChange(val) {
            this.searchParams.page = 1;
            this.searchParams.limit = val;
            this.getFollowsRecordsList();
        },
        handleCurrentChange(val) {
            this.searchParams.page = val;
            this.getFollowsRecordsList();
        },
        handleClose(val) {
            this.$emit('closeDialog');
        },
        TimeChange(val) {
            if (val) {
                this.searchParams.startTime = val[0];
                this.searchParams.endTime = val[1];
            } else {
                this.searchParams.startTime = '';
                this.searchParams.endTime = '';
            }
        },
        searchFolloweType(queryString, cb) {
            if (queryString && queryString.length > 50) {
                queryString = queryString.substring(0, 50);
                this.addRecordsModel.FolloweType = queryString;
            }
            let list = this.followsTypeList;
            this.querySearchAsync(list, queryString, cb);
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Name);
                }
            };
        },
        selectType(item) {
            this.addRecordsModel.FolloweTypeId = item.Id;
            this.addRecordsModel.FolloweTypeOrigin = item.Origin;
        },
        clearType() {
            this.addRecordsModel.FolloweTypeId = '';
            this.addRecordsModel.FolloweTypeOrigin = 1;
            this.addRecordsModel.FolloweType = '';
        },
        //值改变
        typeInput(val) {
            //加计时器是因为input事件的优先级比select事件高
            setTimeout(() => {
                if (this.addRecordsModel.FolloweTypeOrigin == 0 && val) {
                    let followstype = this.followsTypeList.find(item => item.Id == this.addRecordsModel.FolloweTypeId);
                    if (followstype.Name != val) {
                        this.$util.warningMsg('系统跟进类型不可修改');
                        this.addRecordsModel.FolloweType = followstype.Name;
                        return;
                    }
                }
            }, 1000);
        },
        onSubmit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    that.loading = true;
                    that.$util
                        .axiosPost({
                            url: '/api/EntpCustomers/AddFollowsRecord',
                            data: that.addRecordsModel
                        })
                        .then(response => {
                            if (response.errcode == 0) {
                                that.$util.successMsg('添加跟进记录成功');
                                that.$refs[formName].resetFields();
                                that.getFollowsTypeList();
                                that.handleSearch();
                            }
                        })
                        .catch(error => {
                            that.loading = false;
                        });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.addRecordsModel.Reserved = false;
            this.addRecordsModel.ReservationTime = '';
        }
    }
};
</script>

<style lang="less" scoped>
.reservationTime {
    .el-form-item__error {
        left: 150px;
    }
}
</style>
